import React from "react";
import { BadgeCheck, FileText, FileSignature, Activity, CalendarCheck, IdCard, ArrowRight, TriangleAlert } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { Btn, Eyebrow, SectionTitle } from "@/components/ui-kit/Kit";
import { Reveal, Stagger, StaggerItem } from "@/components/motion/Reveal";

const CARD_ICONS = [BadgeCheck, FileText, FileSignature, Activity, CalendarCheck, IdCard];

export const SafeTrade = () => {
  const { t } = useI18n();
  const s = t("home.safeTrade");

  return (
    <section
      className="relative overflow-hidden bg-navy-deep py-24 text-white grain sm:py-32"
      data-testid="safe-trade-section"
    >
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 hairline-grid" />
      <div className="relative container">
        <div className="grid gap-10 lg:grid-cols-[1fr_1fr] lg:items-end">
          <Reveal>
            <Eyebrow tone="gold">{s.eyebrow}</Eyebrow>
            <SectionTitle dark className="mt-6 max-w-[16ch]">
              {s.title}
            </SectionTitle>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="max-w-lg text-sm leading-relaxed text-white/60 sm:text-base">{s.body}</p>
          </Reveal>
        </div>

        <Stagger className="mt-16 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {(s.cards || []).map((c, i) => {
            const Icon = CARD_ICONS[i % CARD_ICONS.length];
            return (
              <StaggerItem key={c} className="bg-navy-deep">
                <div className="group flex items-center gap-4 p-7" data-testid={`safe-trade-card-${i + 1}`}>
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/15 transition-colors duration-500 group-hover:border-gold">
                    <Icon className="h-5 w-5 text-grn transition-colors duration-500 group-hover:text-gold" strokeWidth={1.5} />
                  </span>
                  <span className="font-display text-base font-medium">{c}</span>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>

        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-col gap-7 border-t border-white/10 pt-9 lg:flex-row lg:items-center lg:justify-between">
            <p className="flex max-w-2xl items-start gap-3 text-[12px] leading-relaxed text-white/55">
              <TriangleAlert className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
              {s.disclaimer}
            </p>
            <Btn to="/safe-trade-network" variant="ghostLight" data-testid="learn-safe-trade">
              {t("cta.learnSafeTrade")} <ArrowRight className="h-4 w-4" />
            </Btn>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
